// extracted by mini-css-extract-plugin
export default {"TutorialModal":"FundingAccountTutorialModal_TutorialModal__l1J4W","TutorialModal__close":"FundingAccountTutorialModal_TutorialModal__close__b0stN"};